import { SVG } from '@svgdotjs/svg.js';

export function applyProductVariantColors(conf, form, extraColorChanged, textColorChanged) {
  const variants = conf.productVariants;

  if (!variants) {
    return;
  }

  const product = form.layerStatus?.[variants.sourceLayer]
    ? form.layerItems?.[variants.sourceLayer]
    : null;

  (conf.extras || []).forEach(extra => {
    if (extra.productColors) {
      extraColorChanged(extra, extra.productColors[product] || extra.defaultColor);
    }
  });

  (conf.texts || []).forEach(text => {
    if (text.colorWithProduct) {
      textColorChanged(text, product ? text.colorWithProduct : text.defaultColor);
    }
  });
}

export function productVariantExtras(conf, form) {
  const variants = conf.productVariants;

  return (conf.extras || []).map(extra => {
    if (!variants || extra.enabledWithoutProduct === undefined) {
      return extra;
    }

    const product = form.layerStatus?.[variants.sourceLayer]
      && variants.texts[form.layerItems?.[variants.sourceLayer]];

    return {
      ...extra,
      color: form.extraColors?.[extra.colorTargetId || extra.id] || extra.defaultColor,
      enabled: form.extraColorStatus?.[extra.id]
        ?? (product ? Boolean(extra.enabled) : Boolean(extra.enabledWithoutProduct)),
    };
  });
}

export function syncProductVariant(conf, form, template, route) {
  const variants = conf.productVariants;

  if (!variants) {
    return false;
  }

  const selectedProduct = form.layerItems?.[variants.sourceLayer];
  const product = form.layerStatus?.[variants.sourceLayer] && variants.texts[selectedProduct]
    ? selectedProduct
    : null;

  SVG('#backgroundImage')?.attr('href', route('social-graphics.brand-background.link', {
    template,
    image: product ? `bg_${product}.jpg` : 'bg_default.jpg',
  }));
  SVG('#backgroundImage')?.removeClass('hidden');

  const text = document.querySelector('div.template svg #productText');

  if (text) {
    text.innerHTML = product ? variants.texts[product] : variants.defaultText;
  }

  const offset = product ? 0 : variants.defaultSloganOffset;
  SVG('#texts')?.attr('transform', `translate(${offset}, 0)`);
  SVG('#headline2')?.attr('transform', `translate(${offset}, 0)`);

  productVariantExtras(conf, form).forEach(extra => {
    if (extra.enabledWithoutProduct !== undefined) {
      const element = SVG(`#${extra.id}`);
      extra.enabled ? element?.show() : element?.hide();
    }
  });

  // An enabled layer without a selection still uses the default version.
  if (!product) {
    SVG(`#${variants.sourceLayer}`)?.addClass('hidden');
  }

  return true;
}
